(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8545],{

/***/ 88545:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Addons; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14140);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89736);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(81380);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_script__WEBPACK_IMPORTED_MODULE_2__);



function Addons(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_script__WEBPACK_IMPORTED_MODULE_2___default()), {
                src: "https://kit.fontawesome.com/3c7cbada9c.js",
                crossOrigin: "anonymous",
                async: true
            }),
            props.hasOwnProperty("script_sections") ? props.script_sections != null ? props.script_sections.map(function(section, key) {
                return(// section.app_section_content
                section.app_section_content != null ? !section.app_section_content.includes("platform") ? section.app_section_content.split("<script>")[1] != null ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                    src: section.app_section_content.split("<script>")[1].split("</script>")[0],
                    defer: true
                }, key) : "" : "" : "");
            }) : "" : ""
        ]
    });
}


/***/ }),

/***/ 81380:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(88512)


/***/ })

}]);